import React from 'react';

const Modal = ({ isOpen, onClose, title, bottomSheet = true, children }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className={`modal ${bottomSheet ? 'bottom-sheet' : ''}`} role="dialog" aria-modal="true">
      <div
        className="modal-overlay"
        role="button"
        tabIndex={0}
        onClick={onClose}
        onKeyDown={e => {
          if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') {
            onClose();
          }
        }}
        aria-label="Close modal"
      />
      <div className="modal-content" role="document">
        <button className="modal-close" aria-label="Close" onClick={onClose}>
          &times;
        </button>
        {title && (
          <div className="modal-header">
            <h2>{title}</h2>
          </div>
        )}
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
